import { FiCheck } from "react-icons/fi";

const FormCheck = ({ register, name, altStatus = false, disabled, formLabel, error, editable = true, margin = true }) => (
	<>
		{editable ? (
			<div className={`form-check ${margin ? "mt-0 mb-3 ml-2" : ""}`}>
				<label className="form-check-label" style={{ ...(disabled ? { pointerEvents: "none" } : {}) }}>
					<input className="form-check-input" type="checkbox" {...register(name)} />
					<span className="form-check-sign"></span>
					{formLabel}
				</label>
			</div>
		) : (
			altStatus && (
				<div className={`${margin ? "mb-4 mt-2" : ""} d-flex align-items-center`}>
					<span className={`text-dark text-nowrap ${altStatus ? "bg-success" : "bg-danger"} px-3 py-2 rounded`}>
						<small>{formLabel}</small>
						<FiCheck className="text-dark ml-2" size={22} />
					</span>
				</div>
			)
		)}
		{error && (
			<div className="text-center">
				<small className="text-danger">{error?.message}</small>
			</div>
		)}
	</>
);

export default FormCheck;
